import React from 'react';

import { Box, Divider } from 'vindi-ds-components';

import useToggle from '@hooks/feature_toggles';

import HeaderBills from './components/header';
import ListBills from './components/list';
import NotificationModal from '../components/notificationModal';

function Bills() {
  const toggle = useToggle('new_ds_bills');

  if (!toggle) { return (<NotificationModal />); }

  return (
    <Box mb={10}>
      <HeaderBills />

      <Divider />

      <ListBills />
    </Box>
  );
}

export default Bills;
